/**
 * Workflow keys group step types by the high-level user-facing process they belong to.
 *
 * This is a frontend / domain concept (not a DB enum): the API already organizes code under
 * `apps/api/src/modules/workflows/{cost-estimate,damage-appraisal,inbox-processing}`, and the UI
 * needs the same grouping to drive shared affordance such as the "Bucket beenden" banner action.
 *
 * Keys mirror the API folder names so the mental model is identical on both sides.
 *
 * Adapter URL routes use kebab-case (URL convention), so the corresponding URL slug for a key
 * replaces underscores with hyphens — see `overviewWorkflowSlug` in
 * `apps/web/src/api/incidents/incidentOverviewQueryOptions.ts`. The schema discriminator in
 * `packages/schemas/src/zod/incidentOverview/` matches the slug, not the key.
 */
export const workflowKey = {
    COST_ESTIMATE: "cost_estimate",
    DAMAGE_APPRAISAL: "damage_appraisal",
    INVOICE: "invoice",
    INBOX_PROCESSING: "inbox_processing",
    INCIDENT_REPORT: "incident_report",
    // Shared by all document task types, like INBOX_PROCESSING.
    DELETE_TASK: "delete_task",
};
